<div class="flex items-center h-[100vh] overflow-hidden">
  <!-- Left Section with Image -->
  <div class="hidden text-center md:w-1/2 md:flex">
    <img
      src="/images/login.png"
      alt="Login Image"
      class="object-cover w-full h-full" />
  </div>

  <!-- Right Section with Form -->
  <div class="w-[100%] md:w-1/2 flex justify-center items-center h-[100vh]">
    <div class="block w-[90%] md:w-[75%] mx-auto">
      <h2 class="text-center text-[30px] md:text-[40px] font-[35px] font-sans">
        Cladded Glass Broadband
      </h2>
      <h3 class="text-center text-[20px] md:text-[30px] mb-5">
        Reset your password
      </h3>
      <div class="mb-3 p-field">
        <label for="email" class="mb-1">Email</label>
        <input
          class="p-3 text-black bg-white rounded-lg hover:bg-medium_blue-900"
          id="email"
          type="email"
          pInputText
          [(ngModel)]="email"
          placeholder="Enter your email" />
      </div>

      <div class="py-3 text-center account-switch">
        <p>
          If an account with this email address is found, you will receive a link to reset your password. If you have any problems, please contact support&#64;claddedglass.com
        </p>
      </div>

      <!-- Login Button -->
      <div class="flex items-center justify-start mb-4 space-x-5">
        <button
          pButton
          class="p-3 shadow-xs bg-primary-500 hover:bg-medium_blue-800 min-w-48"
          label="Request Reset Link"
          (click)="resetLink()"></button>
      </div>
      <div class="py-3 text-center account-switch">
        <p>
          Already have an account?
          <a routerLink="/login" class="switch-link">Sign in instead</a>
        </p>
      </div>
    </div>
  </div>
</div>
